// Shared shimmer + card-skeleton styling. Used by Skeleton.tsx for every
// card type's loading state. The shimmer color is theme-driven (--wg-*).
export const SKELETON_CSS = /* css */ `
  @keyframes lk-shimmer {
    0%   { background-position: -240px 0; }
    100% { background-position: calc(240px + 100%) 0; }
  }
  .lk-skeleton {
    background-color: var(--wg-border, #e6e8eb);
    background-image: linear-gradient(
      90deg,
      rgba(0,0,0,0) 0,
      rgba(0,0,0,0.06) 50%,
      rgba(0,0,0,0) 100%
    );
    background-size: 240px 100%;
    background-repeat: no-repeat;
    animation: lk-shimmer 1.2s ease-in-out infinite;
    border-radius: 6px;
  }
  .lk-skeleton-line { margin: 5px 0; }

  .lk-card-skeleton-row {
    display: flex; gap: 16px; overflow: hidden;
    padding: 8px 4px 24px; margin: 0 -4px;
  }
  .lk-card-skeleton {
    flex: 0 0 auto; width: 240px;
    border-radius: 14px; overflow: hidden;
    background: var(--wg-bg); box-shadow: var(--wg-card-shadow);
    display: flex; flex-direction: column;
    animation: lk-card-in 0.25s ease;
  }
  .lk-card-skeleton-image { height: 160px; border-radius: 0; }
  .lk-card-skeleton-body { padding: 12px 14px 14px; }
  .lk-card-skeleton-bottom {
    display: flex; justify-content: space-between; align-items: center;
    margin-top: 10px;
  }
`;
